<template>
  <v-slide-y-transition mode="out-in" v-if="displayCard">
    <v-flex v-show="display && hasResults()" :class="columns">
      <v-card class="centered stats-card" :height="height + 'px'"> 
        <v-card-title
          ref="cardTitle"
          v-if="title || subtitle"
          class="stats-card-title"
          primary-title
        >
          <v-layout justify-end>
            <v-flex xs10>
              {{ title }}
              <p class="stats-card-subtitle">{{ subtitle }}</p>
            </v-flex>
            <v-flex xs2>
              <v-menu
                v-model="menu"
                class="stats-card-settings-icon"
                :close-on-content-click="false"
                offset-y
                nudge-left
                left
              >
                <template slot="activator">
                  <v-btn
                    flat
                    icon
                    class="card-settings-btn"
                  >
                    <v-icon class="on-refresh">settings</v-icon> 
                  </v-btn>
                </template>

                <v-card>
                  <v-list>
                    <v-list-tile
                        v-if="isAvailableOption('legend', 'display')"
                      >
                      <v-list-tile-action>
                        <v-switch
                          v-model="item.options.legend.display"
                          color="indigo"
                          @change="onToogleOption"></v-switch>
                      </v-list-tile-action>
                      <v-list-tile-title>
                        {{ trans.legends || 'Legends' }}
                      </v-list-tile-title>
                    </v-list-tile>

                    <v-list-tile
                        v-if="isAvailableOption(
                          'scales.yAxes.0.gridLines',
                          'drawBorder'
                        )"
                      >
                      <v-list-tile-action>
                        <v-switch
                          v-model="item.options.scales.xAxes[0].gridLines.drawBorder"
                          @change="onToogleOption"
                          color="indigo"></v-switch>
                      </v-list-tile-action>
                      <v-list-tile-title>
                        {{ trans.xAxesDrawBorder|| 'Horizontal border' }}
                      </v-list-tile-title>
                    </v-list-tile>

                    <v-list-tile
                        v-if="isAvailableOption(
                          'scales.yAxes.0.gridLines',
                          'display'
                        )"
                      >
                      <v-list-tile-action>
                        <v-switch
                          v-model="item.options.scales.yAxes[0].gridLines.display"
                          @change="onToogleOption"
                          color="indigo"></v-switch>
                      </v-list-tile-action>
                      <v-list-tile-title>
                        {{ trans.yAxesGridlines|| 'Horizontal gridlines' }}
                      </v-list-tile-title>
                    </v-list-tile>

                    <v-list-tile
                        v-if="isAvailableOption(
                          'scales.yAxes.0.ticks',
                          'display'
                        )"
                      >
                      <v-list-tile-action>
                        <v-switch
                          v-model="item.options.scales.xAxes[0].ticks.display"
                          @change="onToogleOption"
                          color="indigo"></v-switch>
                      </v-list-tile-action>
                      <v-list-tile-title>
                        {{ trans.xAxesTicks|| 'Horizontal ticks' }}
                      </v-list-tile-title>
                    </v-list-tile>

                    <v-list-tile
                        v-if="isAvailableOption(
                          'scales.yAxes.0.gridLines',
                          'drawBorder'
                        )"
                      >
                      <v-list-tile-action>
                        <v-switch
                          v-model="item.options.scales.yAxes[0].gridLines.drawBorder"
                          @change="onToogleOption"
                          color="indigo"></v-switch>
                      </v-list-tile-action>
                      <v-list-tile-title>
                        {{ trans.yAxesDrawBorder|| 'Vertical border' }}
                      </v-list-tile-title>
                    </v-list-tile>

                    <v-list-tile
                        v-if="isAvailableOption(
                          'scales.yAxes.0.gridLines',
                          'display'
                        )"
                      >
                      <v-list-tile-action>
                        <v-switch
                          v-model="item.options.scales.xAxes[0].gridLines.display"
                          @change="onToogleOption"
                          color="indigo"></v-switch>
                      </v-list-tile-action>
                      <v-list-tile-title>
                        {{ trans.xAxesGridlines|| 'Vertical gridlines' }}
                      </v-list-tile-title>
                    </v-list-tile>

                    <v-list-tile
                        v-if="isAvailableOption(
                          'scales.xAxes.0.ticks',
                          'display'
                        )"
                      >
                      <v-list-tile-action>
                        <v-switch
                          v-model="item.options.scales.yAxes[0].ticks.display"
                          @change="onToogleOption"
                          color="indigo"></v-switch>
                      </v-list-tile-action>
                      <v-list-tile-title>
                        {{ trans.yAxesTicks|| 'Vertical ticks' }}
                      </v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-card>
              </v-menu>
            </v-flex>
          </v-layout>

        </v-card-title>
        <v-card-text>


    <v-slide-y-transition mode="out-in">
          <vue-chart
            :id="id"
            ref="cardText"
            v-if="visible"
            class="stats-card-chart"
            :height="chartSize"
            :width="chartSize"
            :type="item.type"
            :chart-data="chartData || {}"
            :options="item.options || {}"
          ></vue-chart>
  </v-slide-y-transition>
  </v-card-text>
        <v-card-actions class="stats-card-actions">

            <v-layout
              ref="cardLabels"
              wrap
              class="chart-legends"
              v-show="get('options.customLegend.display', false)"
              >
                <div
                  class="chart-legend"
                  v-for="(label, i) in group ? item.groups : item.labels" :key="i"
                >
                  <span
                    class="chart-legend-badge"
                    :style="{
                      backgroundColor: label.active ? label.backgroundColor : 'rgba(154, 154, 154, 0.87)',
                      border: label.borderWidth + 'px solid ' + (label.active ? label.borderColor : 'rgba(154, 154, 154, 0.87)'),
                    }
                  "></span>
                  <span
                    @click="onClickLabel(i)"
                    class="chart-legend-text"
                    :style="{ 
                      textDecoration: label.active ? 'unset' : 'line-through'
                    }"
                  >
                    {{ label.text }}
                  </span>
                </div>
            </v-layout>
          <v-layout ref="cardActions" justify-end>
            <v-flex xs8 class="since">
              <v-btn
                flat
                icon
                class="stats-button refresh-btn"
                @click="onRefresh()">
                <v-icon class="on-refresh">autorenew</v-icon> 
              </v-btn>
              <span v-if="updateSince" class="stats-card-subtitle autorenew">
                {{ trans.lastUpdateText || 'Updated' }} {{ updateSince }}
              </span>
            </v-flex>
            <v-flex xs4 v-if="displayControlButtons">
              <v-layout row class="stats-action-buttons">
                <v-flex xs12>
                  <v-btn
                    @click="onLastChart()"
                    :disabled="currentItemIndex === 0"
                    flat
                    icon
                    class="change-charts-button"
                  >
                    <v-icon>keyboard_arrow_left</v-icon>
                  </v-btn>
                  <v-btn
                    @click="onNextChart()"
                    :disabled="items.length === currentItemIndex + 1"
                    flat
                    icon
                    class="change-charts-button"
                  >
                    <v-icon>keyboard_arrow_right</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-slide-y-transition>
</template>

<script>
  'use strict'

  import moment from 'moment'
  import VueChart from 'components/vue-chart/vue-chart'

  export default {

    name: 'VuetifyChartCard',

    components:
    {
      VueChart
    },

    props: {
      id: {
        type: String,
        default: 'chart'
      },
      items: {
        type: Array,
        required: true
      },
      columns: {
        type: String,
        default: 'xs12 sm6 md6 lg6 xl4'
      },
      title: {
        type: String,
        default: ''
      },
      subtitle: {
        type: String,
        default: ''
      },
      height: {
        type: Number,
        default: 500
      },
      trans: {
        type: Object,
        default: () => { return {} }
      },
      group: {
        type: Boolean,
        default: false
      },
      display: {
        type: Boolean,
        default: true
      },
      displayControlButtons: {
        type: Boolean,
        default: true
      }
    },

    data: () => ({
      displayCard: false,
      chartSize: 'auto',
      labelHeight: 0,
      chartData: {},
      visible: true,
      visi: false,
      menu: false,
      message: false,
      hints: true,
      on: false,
      currentItemIndex: 0,
      lastUpdate: moment().toISOString(),
      labels: [],
      currentLabels: []
    }),

    mounted () {
      window.addEventListener('resize', () => {
        this.setChartHeight()
      })
    },

    created () {
      if (!this.hasValidData()) {
        return console.warn('No valid data were received', this.item)
      }
      setInterval(() => { this.uploadTimes() }, 1000)
      this.setLabels(false)
      this.renderChart()
      this.displayCard = true
      setTimeout(() => { this.setChartHeight() }, 1)
    },

    watch: {
      'items.0.data.labels': {
        handler: function (newVal, oldVal) {
          this.$emit('on-change-items', this.id, newVal, oldVal)
          this.lastUpdate = moment().toISOString()
          this.uploadTimes()
          this.setLabels(false)
          this.currentItemIndex = 0
        },
        deep: false
      },
      item: {
        handler: function (newVal, oldVal) {
          if (!this.hasValidData()) {
            this.displayCard = false
            return console.warn('No valid data were received', this.item)
          }
          this.$emit('on-change-item', this.id, newVal, oldVal)
          this.setLabels(true)
          this.renderChart()
          setTimeout(() => { this.setChartHeight() }, 1)
        },
        deep: true
      }
    },

    methods: {
      onToogleOption () {
        this.visible = false
        setTimeout(() => {
          this.visible = true
        }, 10)
      },
      renderChart () {
        this.setChartData()
        this.setChartDatasets()
      },

      hasValidData () {
        return this.get('data.labels', false) !== false &&
               this.get('data.datasets', false) !== false
      },

      onNextChart () {
        this.currentItemIndex++
        this.$emit('on-next-chart', this.id, this.item)
      },

      onLastChart () {
        this.currentItemIndex--
        this.$emit('on-next-chart', this.id, this.item)
      },

      uploadTimes () {
        this.lastUpdate = moment(this.lastUpdate)
      },

      onRefresh () {
        this.$emit('on-refresh', this.id, this.item)
      },

      onClickLabel (index) {
        this.invertLabelState(index)
      },

      hasResults () {
        let data = this.get('data.datasets.0.data', [0])
        return !data.every(item => item === 0)
      },

      invertLabelState (index) {
        let label = this.group ? this.item.groups[index] : this.item.labels[index]
        label.active = !label.active
        this.renderChart()
      },

      get (key, def, arr) {
        arr = arr || Object.assign({}, this.item)
        let keys = key.split('.')
        let i, max
        for (i = 0, max = keys.length; i < max; i++) {
          if (arr.constructor.name !== 'Array' && arr.constructor.name !== 'Object') {
            return def
          }
          arr = arr[keys[i]] || arr[keys[parseInt(i)]]
          if (arr === undefined) {
            return def
          }
        }
        return arr
      },

      isAvailableOption (obj, key) {
        let prefix = 'options.' + obj + '.'
        return this.get(prefix + 'displayOption', true) &&
               this.get(prefix + key, undefined) !== undefined
      },

      setChartData () {
        this.chartData = Object.assign({}, this.item.data || {})
        this.chartData.datasets = []
        this.chartData.labels = []
      },

      setLabels (check) {
        let dataset = this.get('data.datasets.0', {})
        this.item.labels = []
        this.item.data.labels.forEach((label, index) => {
          this.item.labels.push({
            text: label,
            active: this.get('labels.index.active', true),
            backgroundColor: this.getDatasetColor('backgroundColor', dataset, index),
            borderColor: this.getDatasetColor('borderColor', dataset, index),
            borderWidth: this.getChartBorderWidth(dataset)
          })
        })
        this.item.groups = []
        this.item.data.datasets.forEach((dataset, index) => {
          this.item.groups.push({
            text: dataset.label,
            active: this.get('groups.index.active', true),
            backgroundColor: this.getDatasetColor('backgroundColor', dataset, index),
            borderColor: this.getDatasetColor('borderColor', dataset, index),
            borderWidth: this.getChartBorderWidth(dataset)
          })
        })
      },

      getChartBorderWidth (dataset) {
        return parseInt(this.get('borderWidth', 0, dataset)) > 0 ? 1 : 0
      },

      setChartDatasets () {
        this.item.groups.forEach((group, groupIndex) => {
          if (group.active) {
            let dataset = this.item.data.datasets[groupIndex]
            this.chartData.datasets.push(Object.assign({}, dataset))
            let index = this.chartData.datasets.length - 1
            let current = this.chartData.datasets[index]
            current.data = []
            current.backgroundColor = []
            current.borderColor = []
            this.item.labels.forEach((label, labelIndex) => {
              if (label.active) {
                if (index === 0) {
                  this.chartData.labels.push(label.text)
                }
                current.data.push(dataset.data[labelIndex])

                let notResults = !this.group && dataset.data[labelIndex] === 0

                let backgroundColor = notResults ? 'transparent' : this.getDatasetColor('backgroundColor', dataset, labelIndex)

                if (!this.group) {
                  current.backgroundColor.push(backgroundColor)
                } else {
                  current.backgroundColor = backgroundColor
                }

                let borderColor = notResults ? 'transparent' : this.getDatasetColor('borderColor', dataset, labelIndex)

                if (!this.group) {
                  current.borderColor.push(borderColor)
                } else {
                  current.borderColor = borderColor
                }
              }
            })
          }
        })
      },

      getDatasetColor (type, dataset, index) {
        let color = this.get(type + '.' + index, false, dataset) ||
                    this.get(type + '.0', false, dataset) ||
                    this.get(type, false, dataset) || 'rgb(189, 189, 189)'
        return color
      },

      setChartHeight () {
        if (this.$refs.cardTitle) {
          this.visible = false
          let size = this.height - 18 - (this.$refs.cardLabels.offsetHeight + this.$refs.cardActions.offsetHeight + this.$refs.cardTitle.offsetHeight)

          size = (size > this.$refs.cardActions.offsetWidth ? this.$refs.cardActions.offsetWidth : size)
          this.chartSize = size + 'px'
          this.visible = true
        } else {
          this.chartSize = '100%'
        }
      }
    },

    computed: {
      item () {
        return this.items[this.currentItemIndex] || {}
      },
      updateSince () {
        return moment(this.lastUpdate).fromNow()
      }
    }
  }
</script>

<style lang="sass">
.stats-card
  background-color: rgba(255, 255, 255, 0) !important
  overflow: hidden
  margin: 0px auto

.stats-card-title
  margin: 0
  padding: 23px 12px 15px 24px
  color: #252422
  font-weight: 300
  display: grid

.stats-card-subtitle
  font-size: 14px
  font-weight: 400
  color: #9a9a9a
  margin-bottom: 0
  line-height: 1.4em

.stats-card-chart
  padding: 5px
  overflow: hidden


.change-charts-button
  color: #9E9E9E !important

.refresh-btn,
.card-settings-btn
  margin-top: -2px !important
  margin-left: 13px !important
  margin-right: -4px !important
  color: rgba(154, 154, 154, 0.87) !important

.refresh-icon
  font-size: 20px
  color: rgba(154, 154, 154, 0.87) !important

.autorenew
  color: rgba(154, 154, 154, 0.87) !important

.stats-action-buttons
  float: right

.since
  max-width: 275px
  white-space: nowrap
  overflow: hidden
  text-overflow: ellipsis

.stats-card-actions
  display: block
  width: -webkit-fill-available
  position: absolute
  bottom: 0
  -webkit-user-select: none
  -moz-user-select: none    
  -ms-user-select: none      
  user-select: none

.chart-legends
  -webkit-transition:width 300ms ease-in-out, height 300ms ease-in-out
  -moz-transition:width 300ms ease-in-out, height 300ms ease-in-out
  -o-transition:width 300ms ease-in-out, height 300ms ease-in-out
  transition:width 300ms ease-in-out, height 300ms ease-in-out
  padding: 12px 16px
  margin: 2px auto !important
  -webkit-user-select: none
  -moz-user-select: none    
  -ms-user-select: none      
  user-select: none

.chart-legend
  display: -webkit-box
  padding: 4px 4px
  text-align: center
  margin: 0px auto

.chart-legend-text
  font-size: 12.5px
  padding: 4px
  cursor: pointer
  color: #787878

.chart-legend-badge
  display: inline-table
  border-radius: 15px
  width: 12px
  height: 12px
  margin-bottom: -1px

.stats-card-settings-icon
  right: 0
  position: absolute
  right: 18px
  top: 18px
</style>



// WEBPACK FOOTER //
// src/components/vuetify-chart-card.vue